/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { useRef, useEffect } from 'react';
import { d as debounce_1 } from '../_chunks/dep-407a3536.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-762fb0bd.js';
import '../_chunks/dep-4929b64e.js';
import '../_chunks/dep-1e4c771d.js';

var DEFAULT_OPTIONS = {
  debounceTime: 0,
  config: {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true
  }
};
function useMutationObservable(targetEl, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;
  var observeRef = useRef(null);
  useEffect(function () {
    if (!cb || typeof cb !== "function") return;
    var debounceTime = options.debounceTime;
    observeRef.current = new MutationObserver(debounceTime > 0 ? debounce_1(cb, debounceTime) : cb);
  }, [cb, options]);
  useEffect(function () {
    if (!targetEl || !(targetEl !== null && targetEl !== void 0 && targetEl.nodeType)) return;
    var config = options.config;
    try {
      observeRef.current.observe(targetEl, config);
    } catch (e) {
      console.error(e);
    }
    return function () {
      observeRef.current.disconnect();
    };
  }, [targetEl, options]);
}

export { useMutationObservable as default };
//# sourceMappingURL=useMutationObserver.js.map
